import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qb-guide-public',
  templateUrl: './qb-guide-public.component.html',
  styleUrls: ['./qb-guide-public.component.scss']
})
export class QbGuidePublicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
